var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:cart-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.625 23.625C10.1082 23.625 10.5 23.2332 10.5 22.75C10.5 22.2668 10.1082 21.875 9.625 21.875C9.14175 21.875 8.75 22.2668 8.75 22.75C8.75 23.2332 9.14175 23.625 9.625 23.625Z",
    stroke: "#AFA9A9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.875 23.625C22.3582 23.625 22.75 23.2332 22.75 22.75C22.75 22.2668 22.3582 21.875 21.875 21.875C21.3918 21.875 21 22.2668 21 22.75C21 23.2332 21.3918 23.625 21.875 23.625Z",
    stroke: "#AFA9A9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.625 4.375H6.125L8.75 19.25H22.75",
    stroke: "#AFA9A9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.75 15.75H22.3913C22.4924 15.7501 22.5905 15.7151 22.6688 15.651C22.7471 15.5868 22.8007 15.4976 22.8205 15.3984L24.3955 7.52336C24.4083 7.45986 24.4067 7.39433 24.391 7.3315C24.3753 7.26867 24.3459 7.21011 24.3048 7.16004C24.2637 7.10997 24.2121 7.06964 24.1535 7.04196C24.095 7.01429 24.031 6.99996 23.9662 7H7",
    stroke: "#AFA9A9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIco);
export default __webpack_public_path__ + "static/media/cart-ico.c435345f866e5b307e86a545a7012a8a.svg";
export { ForwardRef as ReactComponent };